import * as Turbo from '@hotwired/turbo';
import 'alpine-turbo-drive-adapter';
import './alpine';
import './turbo';

window.disableSmoothScroll = () => {
  document.documentElement.setAttribute('class', 'disable-smooth-scroll');
};

window.enableSmoothScroll = () => {
  return document.documentElement.removeAttribute('class');
};
